const ITEMS = [
    "KRAFTANGAN TEMPATAN",
    "REKAAN KUSTOM",
    "KAYU TAHAN CUACA",
    "PENGUDARAAN MESRA KUCING",
    "PENGHANTARAN SELURUH MALAYSIA",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="marquee"
            className="relative border-y border-border bg-surface/40 py-6 overflow-hidden"
        >
            <div className="marquee-track">
                {row.map((t, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-display italic text-3xl md:text-5xl text-ink-soft/70 px-8">
                            {t}
                        </span>
                        <span className="text-accent text-2xl">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};
